import { render, staticRenderFns } from "./HouseComponentDefectGroupForm.vue?vue&type=template&id=11fef405&"
import script from "./HouseComponentDefectGroupForm.vue?vue&type=script&lang=js&"
export * from "./HouseComponentDefectGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports